import { Edit } from "@mui/icons-material";
import { Box, IconButton, TextField } from "@mui/material";
import DrawerWrapper from "components/DrawerWrapper";
import { useState } from "react";
import { DesktopDatePicker } from "@mui/lab";
import { handleKeyDown } from "utils/keyDownPrevent";
import { StyledTextField } from "views/task-view/Details/Fields";
import { DateTypes } from "data/constants";
import moment from "moment";
import LoadingButton from "components/LoadingButton";
import { useMutation, useQueryClient } from "react-query";
import { createRequestDocument } from "api/services/storage";
import { snack } from "components/toast";
import UploadAttachmentModal from "views/task-view/attachments/UploadAttachmentModal";

const createDocumentDefaultValues = {
    documentName: "",
    description: "",
    uploadDocs: null,
};

function CreateDocument(props: { open: boolean; setOpen: (open: boolean) => void }) {

    const [state, setState] = useState<any>(createDocumentDefaultValues);
    const [error, setError] = useState<string | null>(null);
    const { open, setOpen } = props;
    const [openUploadModal, setOpenUploadModal] = useState(false);
    const queryClient = useQueryClient();
    const clientId = localStorage.getItem("clientId") || "";
    const [opendServiceDialog, setOpenServiceDialog] = useState(false);
    const [isDatePickerOpen, setIsDatePickerOpen] = useState<any[]>([false]);
    const [forFocus, setForFocus] = useState<Boolean[]>([true]);

    const { mutate, isLoading } = useMutation(createRequestDocument, {
        onSuccess: () => {
            snack.success("Document Request Submitted");
            setState(createDocumentDefaultValues);
            setOpen(false);
            queryClient.invalidateQueries("requested-documents");
        },
        onError: (err: any) => {
            snack.error(err.response.data.message);
        },
    });

    const handleSubmit = () => {
        if (!state.documentName) {
            snack.error("Please enter a document name");
            return;
        }
        mutate({
            documentName: state.documentName,
            description: state.description,
            clientId: clientId,
            uploadDocs: state.uploadDocs,
        });
    };

    return (
        <DrawerWrapper
            open={open}
            setOpen={() => {
                setState(createDocumentDefaultValues);
                setOpen(false);
            }}
            title="Document Request Creation"
        >
            <Box display="flex" flexDirection="column" gap={2} mt={1}>
                <TextField label="Document Name" fullWidth variant="outlined" placeholder="Select Service" value={state.documentName} onChange={(e) => setState({ ...state, documentName: e.target.value })} />
                <TextField label="Upload Docs" fullWidth disabled variant="outlined" placeholder="Upload Docs" value={state.uploadDocs} onChange={(e) => setState({ ...state, uploadDocs: e.target.value })} />
                <TextField
                    label="Description"
                    placeholder="Write your notes here..."
                    rows={3}
                    multiline
                    variant="outlined"
                    fullWidth
                    value={state.description}
                    onChange={(e) => setState({ ...state, description: e.target.value })}
                />
                <LoadingButton
                    loading={isLoading}
                    disabled={isLoading}
                    fullWidth
                    onClick={() => handleSubmit()}
                    loadingColor="white"
                    title="Request Document"
                    color="secondary"
                    type="submit"
                />
            </Box>
        </DrawerWrapper>
    );
}

export default CreateDocument;